import { NotesV2 } from '../../UI';
import { RealEstateFormValues } from '../types';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';

interface RealEstateNotesInputProps {
  className?: string;
}

export const RealEstateNotesInput = ({ className }: RealEstateNotesInputProps) => {
  const { t: tCommon } = useTranslation('common');
  const { control } = useFormContext<RealEstateFormValues>();
  const { field, fieldState } = useController<RealEstateFormValues, 'notes'>({
    control,
    name: 'notes',
  });

  return (
    <NotesV2
      {...field}
      className={className}
      label={tCommon('notes')}
      defaultValue={field.value}
      status={fieldState.error ? 'errored' : 'normal'}
    />
  );
};
